<template>
    <input type="search" :id="id" v-model="value" :placeholder="placeholder" autocomplete="off" class="form-control">
</template>

<script>
  import axios from 'axios';
  export default {
    name: "AutocompleteInput",
    props: {
      modelValue: String,
      id: {
        type: Number,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      limit: {
        type: Number,
        default: 10
      },
      placeholder: String
    },
    emits: ['update:modelValue', 'select'],
    mounted() {
      $(`#${this.id}`).autocomplete({
        source: (request, response) => {
          axios.get(`${this.url}?query=${request.term}&limit=${this.limit}`)
            .then((res) => {
              if (res.data.success) {
                response(res.data.items);
              }
            });
        },
        select: (event, ui) => {
          this.value = ui.item.label;
          this.$emit('select', this.value);
          return true;
        },
        minLength: 3,
        delay: 600
      })
    },
    computed: {
      value: {
        get() {
          return this.modelValue;
        },
        set (value) {
          this.$emit('update:modelValue', value);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .form-control {
        max-width: 100% !important;
    }
</style>